import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { BarSettingsService } from 'app/services/dal/bar-settings.service';
import { from, of } from 'rxjs';
import { catchError, concatMap, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import * as fromActions from './actions'
import { ToastService } from '../../services/toast.service';
import { shouldLoadData, trackLoading } from '../effect-helpers';
import * as fromBarSettings from './reducer';



@Injectable()
export class BarSettingsEffects {

  constructor(
    private actions$: Actions,
    private store: Store,
    private barSettingsService: BarSettingsService,
    private toastService: ToastService) { }

  selectBar$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fromActions.loadItems),
        shouldLoadData(
          this.store,
          'barSettings',
          (action) => action.barId,
          fromBarSettings.getAllItems
        ),
        switchMap((action) =>
          trackLoading(
            this.store,
            'barSettings',
            action.barId,
            this.barSettingsService.getItems(action.barId).pipe(
              map(items => fromActions.loadItemsSuccess({ items: items })),
              catchError(error => of(fromActions.loadItemsFailure({ error })))
            )
          )
        )
      );
  });

  selectBarSetting$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fromActions.loadItem),
        mergeMap((action) => from(this.barSettingsService.getItemPromise(action.barId))
          .pipe(
            map(item => fromActions.loadItemSuccess({ item: item })),
            catchError(error => of(fromActions.loadItemFailure({ error })))
          )
        )
      );
  });


  updateBar$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fromActions.updateItem),
        concatMap((action) => from(this.barSettingsService.softUpdate(action.update.id.toString(), action.update.changes))
          .pipe(
            map(() => {
              const result = fromActions.updateItemSuccess({ update: action.update });
              this.toastService.saveSuccess();
              return result;
            }),
            catchError(error => of(fromActions.updateItemFailure({ error })))
          )
        )
      );
  });


  handleFetchError$ = createEffect(
    () => {
      return this.actions$
        .pipe(
          ofType(
            fromActions.loadItemsFailure,
            fromActions.loadItemFailure,
            fromActions.updateItemFailure
          ),
          tap(async (action) => {
            await this.toastService.error(action.error)
          }),
        )
    },
    { dispatch: false }
  );



}
